/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_ListingInputs */

const en_featured_listing = /** @type {(inputs: Featured_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Listing`)
};

const id_featured_listing = /** @type {(inputs: Featured_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Unggulan`)
};

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const es_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const fr_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const de_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const ja_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const zh_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const ar_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const it_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const ru_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const pt_featured_listing = en_featured_listing;

/** @type {(inputs: Featured_ListingInputs) => LocalizedString} */
const ko_featured_listing = en_featured_listing;

/**
* | output |
* | --- |
* | "Featured Listing" |
*
* @param {Featured_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const featured_listing = /** @type {((inputs?: Featured_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featured_listing(inputs)
	if (locale === "es") return es_featured_listing(inputs)
	if (locale === "fr") return fr_featured_listing(inputs)
	if (locale === "de") return de_featured_listing(inputs)
	if (locale === "ja") return ja_featured_listing(inputs)
	if (locale === "zh") return zh_featured_listing(inputs)
	if (locale === "ar") return ar_featured_listing(inputs)
	if (locale === "id") return id_featured_listing(inputs)
	if (locale === "it") return it_featured_listing(inputs)
	if (locale === "ru") return ru_featured_listing(inputs)
	if (locale === "pt") return pt_featured_listing(inputs)
	return ko_featured_listing(inputs)
});